"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGlobeSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm3.982 17.303l-.547.546a1.156 1.156 0 00-.299.518c-.073.274-.132.55-.23.817l-.842 2.266a9.67 9.67 0 01-2.064.227v-1.324c.082-.611-.37-1.755-1.095-2.48a1.548 1.548 0 01-.453-1.095v-1.55c0-.562-.304-1.08-.797-1.353a79.83 79.83 0 00-2.362-1.263 6.975 6.975 0 01-1.531-1.052l-.039-.035a5.554 5.554 0 01-.874-1.004 801.746 801.746 0 01-1.673-2.474 9.73 9.73 0 014.993-4.93l1.162.58a.774.774 0 001.12-.692V2.46a9.67 9.67 0 011.18-.118l1.37 1.37a.774.774 0 010 1.095l-.227.226-.5.5a.387.387 0 000 .548l.227.227a.387.387 0 010 .547l-.387.387a.387.387 0 01-.274.113h-.435c-.1 0-.198.04-.27.11l-.48.467a.387.387 0 00-.077.45l.755 1.51a.387.387 0 01-.346.56h-.273a.387.387 0 01-.254-.095l-.449-.39a.775.775 0 00-.752-.15l-1.508.503a.578.578 0 00-.076 1.066l.536.268c.456.228.958.347 1.467.347.509 0 1.093 1.32 1.548 1.548h3.23c.41 0 .804.163 1.095.453l.663.663c.276.277.432.652.432 1.043 0 .6-.24 1.174-.664 1.596zm4.195-4.42a1.161 1.161 0 01-.684-.482l-.87-1.305a1.16 1.16 0 010-1.288l.948-1.422a1.16 1.16 0 01.447-.394l.628-.314A9.601 9.601 0 0121.677 12c0 .42-.035.83-.088 1.236l-1.412-.353z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGlobeSolid;
exports.default = _default;